module.exports = __webpack_public_path__ + "img/pc-en.6456fd06.jpg";